import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "axios";
import { useParams } from "react-router-dom";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";

import NotesSingle from "../../components/Notes/NotesSingle";

function Expenses() {
  const tableRef = React.createRef();
  const navigate = useNavigate();

  // Initialize as empty array to prevent "Invalid prop data" error
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id: expenseId } = useParams();

  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [object_name] = useState('Expense');
  const [selectedRowId, setSelectedRowId] = useState(null);

  useEffect(() => {
    loadExpenses();
  }, []);

  const loadExpenses = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(API + "expenses/", {
        headers: authHeader()
      });

      // Strict check to ensure we get an array
      let rowData = response.data.data || response.data.results || response.data;
      if (!Array.isArray(rowData)) {
        rowData = [];
      }

      setData(rowData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error loading expenses:", error);
      setIsLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/expenses/edit/${id}`);
  };


  const handleDelete = (id) => {
    confirmAlert({
      title: '',
      message: 'Are you sure you want to delete this Expense?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              await axios.delete(API + `expenses/${id}/`, { headers: authHeader() });
              // Optimistic update: remove from UI immediately
              const updatedData = data.filter(item => item.id !== id);
              setData(updatedData);

              toast.success("Expense deleted successfully", {
                position: "top-right",
                autoClose: 1000,
                theme: "light",
              });
            } catch (error) {
              console.error("Error deleting:", error);
              toast.error("Failed to delete expense");
            }
          }
        },
        { label: 'No', onClick: () => { } }
      ]
    });
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="row show_contract show_invoice">
          <div className="">
            <div className="col-md-12">
              <div className="">
                <div className="body">
                  <div className="p-0">
                    <MaterialTable
                      tableRef={tableRef}
                      isLoading={isLoading} // Use internal loading state to prevent crash
                      style={{
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      title={<h5 className="mb-0">{t("Expenses")}</h5>}
                      columns={[
                        {
                          title: "Expense No",
                          field: "expense_number",
                          headerStyle: { fontWeight: "bold", textAlign: "left" },
                          cellStyle: { textAlign: "left", fontSize: 12 },
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none">Expense No</div>
                              <div
                                className="hyperlink"
                                onClick={() => navigate("/expenses/view", { state: rowData.id })}
                              >
                                {rowData.expense_number}
                              </div>
                            </>
                          ),
                        },


                        {
                          title: `${t("Date")}`,
                          field: "expense_date",
                          headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                          cellStyle: { textAlign: "left", fontSize: 12 },
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                              <div>{Helper.DateNormal ? Helper.DateNormal(rowData.expense_date) : rowData.expense_date}</div>
                            </>
                          ),
                        },
                        {
                          title: `${t("Pay To")}`,
                          field: "pay_to",
                          headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                          cellStyle: { textAlign: "left", fontSize: 12 },
                          render: (rowData) => (
                            <>
                              <div>
                                {rowData.pay_to === "Employee"
                                  ? rowData.employee_name || "-"
                                  : rowData.vendor_name || "-"}
                              </div>
                            </>
                          ),
                        },
                        {
                          title: `${t("Category")}`,
                          field: "expense_category",
                          headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                          cellStyle: { textAlign: "left", fontSize: 12 },
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Category")}</div>
                              <span className="badge badge-sm bg-gradient-secondary">{rowData.expense_category}</span>
                            </>
                          ),
                        },
                        {
                          title: `${t("Amount")}`,
                          field: "amount",
                          headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "right" },
                          cellStyle: { textAlign: "right", fontSize: 12 },
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none" style={{ textAlign: 'left' }}>{t("Amount")}</div>
                              <div className="d-none d-xl-block d-lg-block text-right">
                                {Helper.Amount ? Helper.Amount(rowData.amount) : rowData.amount}
                              </div>
                              <div className="d-xl-none d-md-none d-lg-none" style={{ textAlign: "left" }}>{rowData.amount}</div>
                            </>
                          ),
                        },
                        {
                          title: `${t("Notes")}`,
                          field: "",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Notes")}
                              </div>
                              <div
                                onClick={() => {
                                  setIsSidePanelOpen(true);
                                  setSelectedRowId(rowData.id);
                                }}
                              >
                                <span className="cursor-pointer">
                                  {rowData.has_notes ? (
                                    <img
                                      src={process.env.PUBLIC_URL + "/static/assets/img/curved-images/icons8-sticky-notes-96.png"}
                                      alt="notes"
                                      height="30px"
                                      width="30px"
                                    />
                                  ) : (
                                    <img
                                      src={process.env.PUBLIC_URL + "/static/images/iconplus.png"}
                                      alt="add notes"
                                      height="22px"
                                      width="22px"
                                    />
                                  )}
                                </span>
                              </div>
                              {isSidePanelOpen && selectedRowId === rowData.id && (
                                <NotesSingle
                                  setIsSidePanelOpen={setIsSidePanelOpen}
                                  isSidePanelOpen={isSidePanelOpen}
                                  state={selectedRowId}
                                  object_name={object_name}
                                />
                              )}
                            </>
                          ),
                          headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                          cellStyle: { textAlign: "left", fontSize: 12 },
                        },
                      ]}
                      //  - helps visualize how data prop is passed
                      data={data || []} // Crucial Fix: Ensure it's never undefined

                      actions={[
                        (rowData) =>
                          rowData.approval_status !== "Pending" && {
                            icon: () => <img src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"} alt="edit" />,
                            tooltip: "Edit",
                            onClick: (event, rowData) => handleEdit(rowData.id),
                          },
                        (rowData) =>
                          rowData.approval_status !== "Pending" && {
                            icon: () => <img src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"} alt="delete" />,
                            tooltip: "Delete",
                            onClick: (event, rowData) => handleDelete(rowData.id),
                          },
                      ]}
                      components={{
                        Toolbar: (props) => (
                          <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                            <MTableToolbar {...props} />
                            <Link className="navbar-brand m-0" to="/expenses/add">
                              <button className="add-party add btn btn-primary mb-0" id="add-task" type="button">
                                +&nbsp; {t("New Expense")}
                              </button>
                            </Link>
                          </div>
                        ),
                      }}
                      options={{
                        headerStyle: { backgroundColor: "white", color: "#245C7F", fontSize: 12 },
                        rowStyle: (rowData, index) => ({ backgroundColor: index % 2 ? "#fff" : "inherit" }),
                        search: true,
                        paging: true,
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 25, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        emptyRowsWhenPaging: false,
                        actionsColumnIndex: -1,
                      }}
                      localization={{ toolbar: { searchPlaceholder: t("Search Expenses") } }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expenses;